/**
 * Functionality
 */

import detectTabbing from './lib/detect-tabbing'
detectTabbing()

import externalLinks from './lib/external-links'
externalLinks()

import subLinks from './lib/sub-links'
subLinks()

import smoothAnchors from './lib/smooth-anchors'
smoothAnchors()

import vhCheck from 'vh-check'
vhCheck()

/**
 * Components
 */

import './components/Ultralazy.js'
import './components/Slider.js'
import './components/Map/Map.js'
import './components/CornerShape.js'
import './components/Splash.js'
import './components/MainLogo.js'

/**
 * App
 */

import './app.js'